import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getCourseReviews,
  ratingCourse
} from 'store/course-actions';

import StarRatingComponent from 'react-star-rating-component';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import classes from './UserReview.module.css';

const UserReview = props => {
  const dispatch = useDispatch();
  const dataCourseReview = useSelector(state => state.courseInfo);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');

  const showWriteReviewHandler = () => {
    props.showWriteReviewHandler();
  };

  const onStarRating = nextValue => {
    setRating(nextValue);
  };

  const handleChange = () => {
    setReview(event.target.value);
  };

  const sendReview = () => {
    dispatch(ratingCourse(props.dataCourse.idLista, rating, review));
  };

  useEffect(() => {
    if (dataCourseReview.userReview.date) {
      props.showWriteReviewHandler();
      dispatch(getCourseReviews(props.dataCourse.idLista));
    }
  }, [dataCourseReview.userReview, dispatch]);

  return (
    <>
      {!props.showWriteReview ? (
        <>
          <p className={classes.userReviewTitle}>
            Escribir una reseña sobre este curso
          </p>
          <p className={classes.userReviewSubtitle}>
            Comparte tu opinion con la comunidad
          </p>
          <Button
            className={classes.userReviewBtn}
            onClick={showWriteReviewHandler}
          >
            Escribir mi opinión
          </Button>
        </>
      ) : (
        <>
          <Button
            className={classes.backBtn}
            onClick={showWriteReviewHandler}
          >
            <ArrowBackIcon className={classes.backIcon} />
            Regresar
          </Button>
          <aside className={classes.reviewSection}>
            <Typography className={classes.createReviewTitle}>
              Crear reseña
            </Typography>
            <figure className={classes.reviewCourseImage}>
              <img
                className={classes.img}
                src={props.dataCourse.imgPathBig}
                alt={props.dataCourse.nombre}
              />
            </figure>
            <p className={classes.reviewCourseTitle}>
              {props.dataCourse.nombre}
            </p>
            <p className={classes.reviewCourseEmisor}>
              {props.dataCourse.nameEmisor}
            </p>
          </aside>
          <aside className={classes.reviewSection}>
            <Typography className={classes.createReviewTitle}>
              Calificación general
            </Typography>
            <StarRatingComponent
              name="rateCourse"
              starCount={5}
              value={rating}
              starColor="#e6a817"
              emptyStarColor="#d6d6d6"
              onStarClick={onStarRating}
              onStarHover={onStarRating}
              className={classes.starsRatingReview}
            />
          </aside>
          <aside className={classes.reviewSection}>
            <TextField
              id="outlined-textarea"
              label="Escribe tu reseña"
              multiline
              rows="4"
              className={classes.textFieldReview}
              value={review}
              onChange={handleChange}
              margin="normal"
              variant="outlined"
            />
            <div className={classes.sendReviewBtnContainer}>
              <Button
                className={`${
                  review && rating > 0
                    ? classes.btnSendReview
                    : classes.btnSendReviewDisabled
                }`}
                disabled={!(review && rating > 0)}
                onClick={sendReview}
              >
                Enviar
              </Button>
            </div>
          </aside>
        </>
      )}
    </>
  );
};

UserReview.propTypes = {
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showWriteReview: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showWriteReviewHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object
};

export default UserReview;
